class Faqs {
    constructor(sel) {
        // view
        this.components = document.querySelectorAll(sel);

        if (this.components.length) {
            this.init();
        }
    }

    init() {
        this.components.forEach(comp => {
            this.initQuestions(comp);
        })
    }
    initQuestions(comp) {
        const questions = comp.querySelectorAll('.accordion');


        addEventListener("resize", (e) => {
            requestAnimationFrame(() => {
                questions.forEach(faq => {
                    const contentHeight = Number(faq.querySelector('.content').scrollHeight + 30);
                    faq.style.setProperty('--_h', contentHeight + 'px');
                })
            })
        });

        questions.forEach(faq => {
            const contentHeight = Number(faq.querySelector('.content').scrollHeight + 30);

            faq.style.setProperty('--_h', contentHeight + 'px');

            faq.addEventListener('click', () => {
                const isActive = faq.classList.contains('active');
                faq.classList.toggle('active');
                if (isActive) return;
            })
        })
    }
}

const example = new Faqs(".accordions");
